export enum RecipientTypeEnum {
  Individual = 'individual',
  Business = 'business',
}

export enum PaymentMethodTypeEnum {
  Card = 'card',
  BankAccount = 'bank_account',
}

export enum BankAccountTypeEnum {
  Checking = 'checking',
  Savings = 'savings',
}

export enum PaymentMethodRecipientNamePreference {
  PersonalName = 'personal_name',
  BusinessName = 'business_name',
}

export interface DriverPaymentMethod {
  recipientType: RecipientTypeEnum
  paymentMethodType: PaymentMethodTypeEnum
  cardNumberLast4: string | null
  cardExpiration: string | null
  bankAccountType: BankAccountTypeEnum
  bankAccountNumberLast4: string | null
  bankRoutingNumberLast4: string | null
  hasBusinessEntity?: boolean
  businessEntityName?: string | null
}
